module.exports = __webpack_public_path__ + "img/gp.d434f10b.png";